import { FC, useEffect } from 'react'

import { ReactComponent as CodeUpload } from '../../icons/codeUpload.svg'
import { ReactComponent as DocumentUpload } from '../../icons/documentUpload.svg'
import { ReactComponent as DocumentCreate } from '../../icons/documentCreate.svg'
import { ReactComponent as DocumentLink } from '../../icons/documentLink.svg'
import { DialogContent, DialogTitle } from '@mui/material'
import { incrementDocumentationStep, setSelectedDocumentSteps } from '../../store/documentSlice'
import { useDispatch } from 'react-redux'
import "./style.scss"

interface DocumentationModeSelectionProps {
  resetUpload: () => void
}

const codeUploadSteps = [
  'modeSelection',
  'uploadCode',
  'bugsAndErrorHandlingReport',
  'showFunctionalities',
  'showEstimation'
]

const createDocumentSteps = [
  'modeSelection',
  'docInTinyMce'
]


const DocumentationModeSelection: FC<DocumentationModeSelectionProps> = ({ resetUpload }) => {
  const dispatch = useDispatch()
  useEffect(() => {
    resetUpload()
  }, [])

  return (
    <div className='modeContainer'>
      <DialogTitle>
        <div className='document-header'>Create Documentation </div>
        <div className='document-description'>Create your document by selecting any of the option</div>
      </DialogTitle>
      <DialogContent className='modeBodyContainer'>
        <div className="eachMode" onClick={() => { dispatch(setSelectedDocumentSteps(codeUploadSteps)); dispatch(incrementDocumentationStep()) }}>
          <CodeUpload />
          <span className="mode-label">Code Upload</span>
        </div>
        <div className="eachMode disableMode">
          <DocumentUpload />
          <span className="mode-label">Document Upload</span>
        </div>
        <div className="eachMode" onClick={() => { setSelectedDocumentSteps(createDocumentSteps); dispatch(incrementDocumentationStep()) }}>
          <DocumentCreate />
          <span className="mode-label">Create Document</span>
        </div>
        <div className="eachMode disableMode">
          <DocumentLink />
          <span className="mode-label">Document link</span>
        </div>
      </DialogContent>
    </div>
  )
}

export default DocumentationModeSelection